var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.2353L11 2L21 10.2353L21 22H14.75V17.2941C14.75 16.3581 14.3549 15.4603 13.6517 14.7984C12.9484 14.1366 11.9946 13.7647 11 13.7647C10.0054 13.7647 9.05162 14.1366 8.34835 14.7984C7.64509 15.4603 7.25 16.3581 7.25 17.2941V22H1.00001L1 10.2353Z",
    stroke: "#00AAFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.dc9a7320a1a79c468bf0432f9825e06e.svg";
export { ForwardRef as ReactComponent };